module.exports = __webpack_public_path__ + "static/agile-dbda29fa212af8086b74f0c0dc50e3b6.png";